export const MAX_VISIBLE_RECENTS = 5;
export const MAX_VISIBLE_STARRED = 10;
// Upper bound for a single starred fetch so that isStarred filtering covers
// items beyond the visible 10 without following pagination next links.
export const MAX_STARRED_FETCH = 25;

export const SIDE_NAV_VIEW_MODES = {
  STARRED_AND_RECENT: 'starred-and-recent',
  STARRED_ONLY: 'starred-only',
  MOST_RECENT_ONLY: 'most-recent-only',
} as const;

export type SideNavViewMode =
  (typeof SIDE_NAV_VIEW_MODES)[keyof typeof SIDE_NAV_VIEW_MODES];

export const DEFAULT_SIDE_NAV_VIEW_MODE =
  SIDE_NAV_VIEW_MODES.STARRED_AND_RECENT;

export const REPOSITORIES_VIEW_MODE_PREFERENCE_KEY =
  'side-nav-repositories-view-mode';
export const PROJECTS_VIEW_MODE_PREFERENCE_KEY = 'side-nav-projects-view-mode';
// workspace-scoped user pref key that records whether the user has seen the
// starred objects onboarding spotlight. Stored as 'true' once dismissed.
export const STARRED_OBJECTS_ONBOARDING_PREF_KEY =
  'starred-objects-onboarding-seen';

export const isSideNavViewMode = (value: unknown): value is SideNavViewMode =>
  Object.values(SIDE_NAV_VIEW_MODES).includes(value as SideNavViewMode);

export const getSideNavViewMode = (value: unknown): SideNavViewMode =>
  isSideNavViewMode(value) ? value : DEFAULT_SIDE_NAV_VIEW_MODE;

// Menu item IDs for settings links in the sidebar navigation
export const REPO_SETTINGS_ID = 'repo-settings-link';
export const PROJECT_SETTINGS_ID = 'project-settings-link';
